import { Route, Routes } from "react-router-dom";
import { SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";
import { FirebaseObservability } from "@/src/firebase-observability";
import { AuthProvider } from "@/src/auth";
import { ApplyPage } from "@/src/pages/ApplyPage";
import { AboutPage } from "@/src/pages/AboutPage";
import { DashboardPage } from "@/src/pages/DashboardPage";
import { ContactPage } from "@/src/pages/ContactPage";
import { HomePage } from "@/src/pages/HomePage";
import { JobDetailPage } from "@/src/pages/JobDetailPage";
import { JobsPage } from "@/src/pages/JobsPage";
import { LoginPage } from "@/src/pages/LoginPage";
import { NotFoundPage } from "@/src/pages/NotFoundPage";
import { PrivacyPage } from "@/src/pages/PrivacyPage";
import { SettingsPage } from "@/src/pages/SettingsPage";
import { TermsPage } from "@/src/pages/TermsPage";

export function App() {
  return (
    <AuthProvider>
      <a className="skip-link" href="#main">Skip to content</a>
      <FirebaseObservability />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/apply/:id" element={<ApplyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <SiteFooter />
    </AuthProvider>
  );
}
